import React from 'react';
import CartService from 'services/Cart/';
import PubSub from 'services/PubSub/';
import Modal from "components/Modal";
import { actionsType } from 'config/constants';
import { checkoutID } from 'config';
import useVariant from 'hooks/useVariant';
import style from './style.scss'; //NOSONAR

const ModalProductInCart = () => {

    const variant = useVariant(checkoutID);
    const newVariant = variant === '1';

    const _closeModalRepeatOrder = () => {
        setTimeout(() => PubSub.dispatch(actionsType.MODAL.PRODUCT_IN_CART_CLOSE),0);
    }

    const goToCheckout = () => {
        CartService.goToCheckout(null, newVariant);
    }

    return (
        <Modal customClass={'modal-product-cart'} actionOpen={actionsType.MODAL.PRODUCT_IN_CART_OPEN} actionClose={actionsType.MODAL.PRODUCT_IN_CART_CLOSE}>
            <div className="new-modal-container">
                <div className="new-modal-title-wrap"><div className="new-modal-title">¡Producto agregado al carro!</div></div>
                <div className="new-modal-scroll">
                    <i className="modal-product-cart-icon icn added-to-cart"></i>
                </div>
                <div className="modal-actions">
                    <button className="primary-btn modal-product-cart-btn-buy" onClick={_closeModalRepeatOrder}>Seguir comprando</button>
                    <button className="secundary-btn modal-product-cart-btn-order-cart" onClick={goToCheckout}>Hacer pedido</button>
                </div>
            </div>
        </Modal>
    )
}

export default ModalProductInCart;
